import React from "react";
import { Layout } from "../../layouts/Layout";
import { ContactAreaOne } from "../../components/ContactAreas/ContactAreaOne";
import { ContactAreaInner } from "../../components/ContactAreas/ContactAreaInner";
import { ContactAreaMap } from "../../components/ContactAreas/ContactAreaMap";
import { ContactQuickDetails } from "../../components/ContactAreas/ContactQuickDetails";

const ContactPage = () => {
  return (
    <Layout
      breadcrumb={"Contact Us"}
      title={"Contact Us."}
      seo={{
        title: "Contact Zawix Business Consultants",
        description:
          "Contact Zawix Business Consultants in Blue Area Islamabad for company registration, tax, audit, and regulatory compliance services. Call, WhatsApp, or send a message online.",
      }}
    >
      {/* contact form */}
      <ContactAreaOne />

      {/* contact-area */}
      <ContactAreaInner />

      {/* quick details */}
      <ContactQuickDetails />

      {/* map */}
      <ContactAreaMap />
    </Layout>
  );
};

export default ContactPage;
